var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.document)?_c('document-viewer',{ref:"documents",attrs:{"title":_vm.title,"base-uri":_vm.url,"mime":_vm.mime,"allow-email":false},on:{"hide":function($event){return _vm.$emit('hide')}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }